import mock from '@/fake-db/mock.js'
const sampleData = require('./sample-cruises.json');
import mockTaskList from './mock-task-list.js';


mock.onPost('/api/data-list/tasks').reply((p) => {
  console.log('HERE');
  return mockTaskList.onPost(p)
});

mock.onPost('/api/data-list/cruises').reply((p) => {
  const multiSelectFilters = ['region', 'cruiseLine', 'cabinType']
  let filter = JSON.parse(p.data),
    nullFilter = {
      region: [],
      date: null,
      duration: [1, 21],
      priceRange: [0, 500],
      cruiseLine: [],
      cabinType: [],
      importantAmenities: []
    }

  let activeFilterCount = 0
  for (const prop in filter) {
    if (prop == 'importantAmenities') {
      activeFilterCount = activeFilterCount + filter[prop].length
    } else if (JSON.stringify(filter[prop]) === JSON.stringify(nullFilter[prop])) {
      // this filter is still at default value
    } else {
      activeFilterCount++
    }

  }

  let aaiShifter = {
    radiance: 6100,
    ovation: 6000
  };

  const resultsFiltered = sampleData.filter(function (row) {
    // throw out all sample rows that dont match multi select filters
    return multiSelectFilters.map(f => {
      const val = filter[f]
      return !val || val.length == 0 || val.includes(row[f])
    }).reduce((acc, cur) => acc && cur, true)
  }).filter(function (row) {
    // date filter: optional, filter by month
    if (filter.date) {
      return row.date.substr(0, 7) == filter.date.substr(0, 7)
    } else {
      return true
    }
  }).filter(function (row) {
    // range filters
    return ['priceRange', 'duration'].map(function (f) {
      const v = (f == 'priceRange') ? row['price'] : row[f]
      return v >= filter[f][0] && v <= filter[f][1]
    }).reduce((acc, val) => acc && val)
  }).map(function (r) {
    const row = {}
    Object.assign(row, r)
    // artificial intelligence matching score
    if (filter.importantAmenities.includes('Service')) {
      if (row.cruiseLine == 'Royal Caribbean Cruises') {
        row.matchingScore += 10
      } else if (row.cruiseLine == 'Norwegian Cruise Lines') {
        row.matchingScore -= 10
      }
    }
    if (filter.importantAmenities.includes('Food and Beverage')) {
      if (row.cruiseLine == 'Royal Caribbean Cruises') {
        row.matchingScore += 10
      } else if (row.cruiseLine == 'Norwegian Cruise Lines') {
        row.matchingScore += 20
      }
    }
    if (filter.importantAmenities.includes('Wifi')) {
      if (row.region == 'Australasia') {
        row.matchingScore -= 20
      }
    }
    if (filter.importantAmenities.includes('Value for Money')) {
      if (row.region == 'Alaska') {
        row.matchingScore += 20
      }
    }
    if (row.cruiseLine == 'Carnival') {
      row.matchingScore -= 12;
    }
    if (row.cruiseLine == 'Royal Caribbean Cruises') {
      // row.matchingScore += 1;
    }
    if (JSON.stringify(filter.duration) == '[7,9]') {
      if (row.shipName == 'Radiance of the Seas') {
        row.matchingScore += aaiShifter.radiance;
        aaiShifter.radiance = 0;
        console.log('SHIFTED');
      }
      if (row.shipName == 'Ovation of the Seas') {
        row.matchingScore += aaiShifter.ovation;
        aaiShifter.ovation = 0;
      }
    }
    return row
  }).slice(0).sort(function(a,b) {
    return -1* (a.matchingScore>b.matchingScore);
  }).map(function (row, idx) {
    row.totalPrice = row.duration * row.price

    //aai matching scores
    let rawMatchingScore = Math.min(row.matchingScore, 100),
      transformedScore = Math.max(60, Math.min(rawMatchingScore - (activeFilterCount ^ 2) * idx / 2, 100))
    row.matchingScore = transformedScore
    return row
  })

  let suggestedFilterOptions = [
      {
        filter: 'duration',
        val: [7, 9],
        displayVal: '7 - 9 days',
        when: function () {
          return JSON.stringify(filter.duration) == '[1,21]' && activeFilterCount >= 2
        }()
      },
      {
        filter: 'cruiseLine',
        val: ['Norwegian Cruise Lines'],
        displayVal: 'Norwegian Cruise Lines',
        when: function () {
          return filter.cruiseLine.length == 0 && filter.region == 'Alaska' && filter.date != null;
        }()
      },
      {
        filter: 'cruiseLine',
        val: ['Royal Caribbean Cruises'],
        displayVal: 'Royal Caribbean Cruises',
        when: function () {
          return filter.cruiseLine.length == 0 && filter.region == 'Alaska' && filter.date != null;
          //return filter.cruiseLine.length == 0 && activeFilterCount >= 1 // && !filter.importantAmenities.includes('Food and Beverage')
        }()
      }
    ],
    suggestedFilters = suggestedFilterOptions.filter(
      f => f.when == true
    )

  return [
    200, {
      results: resultsFiltered,
      suggestedFilters
    }
  ]
})
